var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVrDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 109,
    viewBox: "0 0 22 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 106.103,
    r: 2.44731,
    transform: "rotate(-90 3.19731 106.103)",
    fill: "#3430E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 93.2089,
    r: 2.44731,
    transform: "rotate(-90 3.19731 93.2089)",
    fill: "#3430E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 80.3144,
    r: 2.44731,
    transform: "rotate(-90 3.19731 80.3144)",
    fill: "#3430E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 67.4199,
    r: 2.44731,
    transform: "rotate(-90 3.19731 67.4199)",
    fill: "#3430E9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 54.5253,
    r: 2.44731,
    transform: "rotate(-90 3.19731 54.5253)",
    fill: "#3430E9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 41.6308,
    r: 2.44731,
    transform: "rotate(-90 3.19731 41.6308)",
    fill: "#3430E9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 28.7363,
    r: 2.44731,
    transform: "rotate(-90 3.19731 28.7363)",
    fill: "#3430E9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 15.8418,
    r: 2.44731,
    transform: "rotate(-90 3.19731 15.8418)",
    fill: "#3430E9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 2.94722,
    r: 2.44731,
    transform: "rotate(-90 3.19731 2.94722)",
    fill: "#3430E9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 106.103,
    r: 2.44731,
    transform: "rotate(-90 19.0918 106.103)",
    fill: "#3430E9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 93.2089,
    r: 2.44731,
    transform: "rotate(-90 19.0918 93.2089)",
    fill: "#3430E9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 80.3144,
    r: 2.44731,
    transform: "rotate(-90 19.0918 80.3144)",
    fill: "#3430E9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 67.4199,
    r: 2.44731,
    transform: "rotate(-90 19.0918 67.4199)",
    fill: "#3430E9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 54.5253,
    r: 2.44731,
    transform: "rotate(-90 19.0918 54.5253)",
    fill: "#3430E9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 41.6308,
    r: 2.44731,
    transform: "rotate(-90 19.0918 41.6308)",
    fill: "#3430E9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 28.7363,
    r: 2.44731,
    transform: "rotate(-90 19.0918 28.7363)",
    fill: "#3430E9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 15.8418,
    r: 2.44731,
    transform: "rotate(-90 19.0918 15.8418)",
    fill: "#3430E9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0918,
    cy: 2.94722,
    r: 2.44731,
    transform: "rotate(-90 19.0918 2.94722)",
    fill: "#3430E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrDots);
export default __webpack_public_path__ + "static/media/vrDots.36018749627504a964a895496028c817.svg";
export { ForwardRef as ReactComponent };